import React, { useEffect, useState } from 'react';
import { getSinglePayment, getPaymentInfo } from '../../../service/PaymentService';
import LoadingSpinner from '../../LoadingSpinner/LoadingSpinner';
import PaymentActivity from '../../PaymentActivity/PaymentActivity';
import PaymentOverview from '../../PaymentOverview/PaymentOverview';
import { useCompany } from '../../../component/CompanySelection/CompanyContext';
import './../SidePanelTabs.css';

export default function PaymentTabs(props) {
    const overviewTab = "overview";
    const activityTab = "activity";
    const [activeTab, setActiveTab] = useState("");
    const [disbursement, setDisbursement ] = useState({});
    const [paymentInfo, setPaymentInfo] = useState({});
    const { companyNumber } = useCompany();

    useEffect(() => {
        if (props?.paymentUUID) {
            getSinglePayment(companyNumber, props.paymentUUID, (result) => {
                setDisbursement(result.disbursement);
                setActiveTab(overviewTab);
            });
            getPaymentInfo(companyNumber, props.paymentUUID, (result) => {
                setPaymentInfo(result.paymentInfoDto);
            });
        }
    }, [props.paymentUUID, companyNumber]);
    

    function handleTabSelection(tab) {
        // Avoid excess reassignment
        if (tab !== activeTab) {
            setActiveTab(tab);
        }
    }

    function retrieveContent() {
        switch (activeTab) {
            case overviewTab:
                return (<PaymentOverview disbursement={disbursement} paymentType={props.paymentType} paymentInfo={paymentInfo} />);
            case activityTab:
                return (<PaymentActivity disbursement={disbursement} />);
            default:
                return (<LoadingSpinner blue data-testid="efup-tabs-loading-spinner" />);
        }
    }

    return (
        <React.Fragment>
            <div className="efup-tab-component" data-testid="efup-tabs-component">
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === overviewTab ? "active" : ""}`}
                            id="overview-tab"
                            type="button"
                            onClick={() => handleTabSelection(overviewTab)}
                            data-testid="efup-overview-tab"
                        >
                            Overview
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === activityTab ? "active" : ""}`}
                            id="activity-tab"
                            type="button"
                            onClick={() => handleTabSelection(activityTab)}
                            data-testid="efup-activity-tab"
                        >
                            Activity
                        </button>
                    </li>
                </ul>
            </div>
            <div className="offcanvas-body">
                <div className="d-lg-block">
                    <div className="tab-content" id="myTabContent">
                        {retrieveContent()}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}